export default __webpack_public_path__ + "static/media/enlarge-icon.04900f88.svg";